// firebase.js

import firebase from "firebase/compat/app"; // Update import statement
import "firebase/compat/messaging"; // Import Firebase Messaging module

const firebaseConfig = {
  apiKey: "AIzaSyDKOAemO9lvrcYA3ACBcxYdA2831dywAi8",
  authDomain: "kingmastar-ecc65.firebaseapp.com",
  projectId: "kingmastar-ecc65",
  storageBucket: "kingmastar-ecc65.firebasestorage.app",
  messagingSenderId: "199458629235",
  appId: "1:199458629235:web:29cc1e5c451ce160636c06",
  measurementId: "G-HKG1RMPS73",
};

const app = firebase.initializeApp(firebaseConfig);

export default app; // Export the initialized Firebase app
